import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, OnInit } from '@angular/core';
import {HasFilter} from '../has-filter';

/** DEPRECIATED: WE ARE NO LONGER SYNCING FILTERS!
 * This is the contents of a filter. This can be useful when trying to build out a pusher filter which has the same contents as
 * the table filters.
 *
 * @Input dateValue: this is the date value for date data types
 * @Output dateValueChange: this allows you to use two-way binding on date values
 *
 * @Input filterValue: this is a string value for string or enumeration data types
 * @Ouput filterValueChange: this allows you to use two-way binding on filter values
 *
 * @Input operation: this is the operation of the filter
 * @Output operationChange: this allows you to use two-way binding on operation
 *
 * @Output menuTrigger: this is triggered when an encapsulating menu should close
 *
 * REQUIRED @Input data: this is the data source being panelFiltered on
 * REQUIRED @Input dataType: this is the type of the data. Accepted values are string, date, and enumeration
 * REQUIRED @Input columnName: this is the name of the column your filtering on
 *
 * @Input columnIndex: used when filtering string[] rather than objects
 * @Input enumerationValues: this is a list of strings that can be selected for enumeration data types
 *
 * @Input trueValue: this is the value of the column when the boolean is true. Defaults to 'Y'.
 * @Input falseValue: this is the value of the column when the boolean is false. Defaults to ''.
 * @Input showTrueLabel: this is the label for the show true checkbox. Defaults to the trueValue.
 * @Input showFalseLabel: this is the label for the show false checkbox. Defaults to the falseValue.
 *
 * @Input operationSelectWidth: the width of the operation selection box. Defaults to 180px.
 * @Input valueWidth: the width of the filter input. Defaults to 180px.
 * @Input operationMarginRight: the space to the right of the operation box. Defaults to 0px.
 * @Input floatLabel: whether or not labels should float above the input. Defaults to auto.
 * @Input fieldsMarginBottom: the size of the bottom margin. Defaults to 0px.
 * @Input showLabel: determines whether or not the label shows up. Defaults to true.
 *
 * @Input pusherMenuStyle: automatically styles the properties for the pusher menu (overrides)
 *
 * @Output filterChange: this event fires the new value only when the value is changed from this component
 * @Output filterOperationChange: this event fires when the operation has been changed by this component. The event is the operation.
 */
@Component({
    selector: 'filter-contents',
    templateUrl: './filter-contents.component.html',
    styleUrls: [
        './filter-contents.component.css'
    ]
})
export class FilterContentsComponent extends HasFilter implements OnInit {

    // Properties

    marginTop = '0px';

    @Output() menuTrigger = new EventEmitter<any>();

    @Input() operationSelectWidth = '180px';
    @Input() valueWidth = '180px';
    @Input() operationMarginRight = '0px';
    @Input() fieldsMarginBottom = '0px';
    @Input() floatLabel = 'auto';
    @Input() showLabel = true;

    @Input() pusherMenuStyle = false;

    @ViewChild('filterInput', { read: ElementRef }) filterInputRef: ElementRef;

    // Class Functions

    // Event Functions
    ngOnInit() {
        // POST: determines what the margin top should be
        if (this.pusherMenuStyle) {
            this.operationSelectWidth = '120px';
            this.operationMarginRight = '10px';
            if (this.dataType != 'date') {
                this.fieldsMarginBottom = '-.5em';
            }
            this.floatLabel = 'never';
            this.showLabel = false;
        }
        if (this.floatLabel == 'never') {
            this.marginTop = '-.5em';
        }

        // Checking if the data source doesn't already have a filter for this
		if (this.data && !this.filterValue && !this.dateValue) {
			const existingFilter = this.data.getFilter(this.columnName);
			if (existingFilter) {
				this.filterValue = existingFilter.value;
				this.dateValue = existingFilter.dateValue;
				this.operation = existingFilter.operator;
			}
		}
    }

    // Methods
}